// ORTable Component
const ORTable = () => (
        <div className="overflow-x-auto">
                <table className="table table-bordered w-full">
                        <thead>
                                <tr>
                                        <th></th>
                                        <th colSpan="2">Monday</th>
                                        <th colSpan="2">Tuesday</th>
                                        <th colSpan="2">Wednesday</th>
                                        <th colSpan="2">Thursday</th>
                                        <th colSpan="2">Friday</th>
                                </tr>
                        </thead>
                        <tbody>
                                {/* OR 1 */}
                                <ORSection
                                        roomName="OR 1"
                                        data={[
                                                {
                                                        doctor: 'Nick',
                                                        activity: 'PR',
                                                        time: '1:00-1:15pm',
                                                        anaesthetist: '',
                                                        radiographer: '',
                                                        assistant: ''
                                                },
                                                {
                                                        doctor: 'Paul',
                                                        activity: 'OR',
                                                        time: '',
                                                        anaesthetist: '',
                                                        radiographer: '',
                                                        assistant: ''
                                                },
                                                {
                                                        doctor: 'Leigh',
                                                        activity: 'PR',
                                                        time: '',
                                                        anaesthetist: '',
                                                        radiographer: '',
                                                        assistant: ''
                                                },
                                                {
                                                        doctor: 'King',
                                                        activity: 'PR',
                                                        time: '1:00-1:15pm',
                                                        anaesthetist: '',
                                                        radiographer: '',
                                                        assistant: ''
                                                },
                                                {
                                                        doctor: 'Hawkins',
                                                        activity: 'PR',
                                                        time: '',
                                                        anaesthetist: '',
                                                        radiographer: '',
                                                        assistant: ''
                                                }
                                        ]}
                                />

                                {/* OR 2 */}
                                <ORSection
                                        roomName="OR 2"
                                        data={[
                                                {
                                                        doctor: 'Nick',
                                                        activity: 'PR',
                                                        time: '',
                                                        anaesthetist: '',
                                                        radiographer: '',
                                                        assistant: ''
                                                },
                                                {
                                                        doctor: 'Paul',
                                                        activity: 'OR',
                                                        time: '1:00-1:15pm',
                                                        anaesthetist: '',
                                                        radiographer: '',
                                                        assistant: ''
                                                },
                                                {
                                                        doctor: 'Leigh',
                                                        activity: 'PR',
                                                        time: '',
                                                        anaesthetist: '',
                                                        radiographer: '',
                                                        assistant: ''
                                                },
                                                {
                                                        doctor: 'King',
                                                        activity: 'PR',
                                                        time: '',
                                                        anaesthetist: '',
                                                        radiographer: '',
                                                        assistant: ''
                                                },
                                                {
                                                        doctor: 'Hawkins',
                                                        activity: 'PR',
                                                        time: '1:00-1:15pm',
                                                        anaesthetist: '',
                                                        radiographer: '',
                                                        assistant: ''
                                                }
                                        ]}
                                />

                                {/* OR 3 */}
                                <ORSection
                                        roomName="OR 3"
                                        data={[
                                                {
                                                        doctor: 'Nick',
                                                        activity: 'PR',
                                                        time: '',
                                                        anaesthetist: '',
                                                        radiographer: '',
                                                        assistant: ''
                                                },
                                                {
                                                        doctor: 'Paul',
                                                        activity: 'OR',
                                                        time: '1:00-1:15pm',
                                                        anaesthetist: '',
                                                        radiographer: '',
                                                        assistant: ''
                                                },
                                                {
                                                        doctor: 'Leigh',
                                                        activity: 'PR',
                                                        time: '',
                                                        anaesthetist: '',
                                                        radiographer: '',
                                                        assistant: ''
                                                },
                                                {
                                                        doctor: 'King',
                                                        activity: 'PR',
                                                        time: '',
                                                        anaesthetist: '',
                                                        radiographer: '',
                                                        assistant: ''
                                                },
                                                {
                                                        doctor: 'Hawkins',
                                                        activity: 'PR',
                                                        time: '1:00-1:15pm',
                                                        anaesthetist: '',
                                                        radiographer: '',
                                                        assistant: ''
                                                }
                                        ]}
                                />
                        </tbody>
                </table>
        </div>
);

// ORSection Component
const ORSection = ({ roomName, data }) => (
        <>
                <tr>
                        <th rowSpan="7">{roomName}</th>
                </tr>
                <tr className="border-t-2 border-gray-300">
                        <th>Doctor</th>
                        <td>{data[0]?.doctor}</td>
                        <th>Doctor</th>
                        <td>{data[1]?.doctor}</td>
                        <th>Doctor</th>
                        <td>{data[2]?.doctor}</td>
                        <th>Doctor</th>
                        <td>{data[3]?.doctor}</td>
                        <th>Doctor</th>
                        <td>{data[4]?.doctor}</td>
                </tr>
                <tr>
                        <th>Activity</th>
                        <td>{data[0]?.activity}</td>
                        <th>Activity</th>
                        <td>{data[1]?.activity}</td>
                        <th>Activity</th>
                        <td>{data[2]?.activity}</td>
                        <th>Activity</th>
                        <td>{data[3]?.activity}</td>
                        <th>Activity</th>
                        <td>{data[4]?.activity}</td>
                </tr>
                <tr>
                        <th>Time</th>
                        <td>{data[0]?.time}</td>
                        <th>Time</th>
                        <td>{data[1]?.time}</td>
                        <th>Time</th>
                        <td>{data[2]?.time}</td>
                        <th>Time</th>
                        <td>{data[3]?.time}</td>
                        <th>Time</th>
                        <td>{data[4]?.time}</td>
                </tr>
                <tr>
                        <th>Anaesthetist</th>
                        <td>{data[0]?.anaesthetist}</td>
                        <th>Anaesthetist</th>
                        <td>{data[1]?.anaesthetist}</td>
                        <th>Anaesthetist</th>
                        <td>{data[2]?.anaesthetist}</td>
                        <th>Anaesthetist</th>
                        <td>{data[3]?.anaesthetist}</td>
                        <th>Anaesthetist</th>
                        <td>{data[4]?.anaesthetist}</td>
                </tr>
                <tr>
                        <th>Radiographer</th>
                        <td>{data[0]?.radiographer}</td>
                        <th>Radiographer</th>
                        <td>{data[1]?.radiographer}</td>
                        <th>Radiographer</th>
                        <td>{data[2]?.radiographer}</td>
                        <th>Radiographer</th>
                        <td>{data[3]?.radiographer}</td>
                        <th>Radiographer</th>
                        <td>{data[4]?.radiographer}</td>
                </tr>
                <tr>
                        <th>Assistant</th>
                        <td>{data[0]?.assistant}</td>
                        <th>Assistant</th>
                        <td>{data[1]?.assistant}</td>
                        <th>Assistant</th>
                        <td>{data[2]?.assistant}</td>
                        <th>Assistant</th>
                        <td>{data[3]?.assistant}</td>
                        <th>Assistant</th>
                        <td>{data[4]?.assistant}</td>
                </tr>
        </>
);

export default ORTable;
